import React, { useState, useEffect } from 'react';
import {
    Grid,
    Card,
    CardContent,
    makeStyles,
    Avatar,
    Checkbox,
    FormControlLabel,
    CardHeader,
    AppBar,
    Tabs,
    Tab,
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { getGrupos, salvarItem } from '../../services/GruposApi';
import { logout } from '../../services/AuthApi';
import { getDesafio, salvarDesafio } from '../../services/DesafioApi';

const useStyles = makeStyles(theme => ({
    avatar: {},
    radiogroup: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    grid: {
        marginTop: theme.spacing(1),
    },
    cardHeader: {},
    cardContent: {},
    item: { display: 'block' },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Desafio = () => {
    const [grupos, setGrupos] = useState([]);
    const { indexGrupo } = useParams();
    const [bibliaOn, setBibliaOn] = useState([]);
    const [isCarregandoGrupo, setCarregandoGrupo] = useState(true);
    const [isCarregandoBibliaOn, setCarregandoBibliaOn] = useState(true);
    const [error, setError] = useState('');
    const classes = useStyles();
    const [grupoSelecionado, setGrupoSelecionado] = useState(false);
    const history = useHistory();
    const [itens, setItens] = useState(Array(100000).fill(false));
    const MAX_ELEMENTS = 40;

    async function fetchGrupos() {
        try {
            const grps = await (await getGrupos()).data;
            setGrupos(grps);
            setCarregandoGrupo(false);
        } catch (err) {
            setError(err);
        }
    }

    async function fetchBibliaOn(idIgreja, idGrupoPequeno) {
        try {
            const response = await (await getDesafio(idIgreja, idGrupoPequeno))
                .data;
            setCarregandoBibliaOn(false);
            return response;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    async function carregarTab(grpSelecionado) {
        setGrupoSelecionado(grpSelecionado);
        if (grpSelecionado) {
            console.log(grpSelecionado);
            const bibliaOnRemoto = await fetchBibliaOn(
                grpSelecionado.idIgreja,
                grpSelecionado.idGrupoPequeno
            );

            const its = {};
            bibliaOnRemoto.forEach((membro, idxMembro) => {
                membro.itens.forEach((item, idxItem) => {
                    its[MAX_ELEMENTS * idxMembro + idxItem] = !!item.aprovado;
                });
            });
            setItens(Array(100000).fill(false));
            setBibliaOn(bibliaOnRemoto);
            setItens(its);
        }
    }

    useEffect(() => {
        if (isCarregandoGrupo && !error) {
            fetchGrupos();
        } else if (grupos.length === 0) {
            logout();
            history.push('/login');
            history.go();
        } else if (indexGrupo) {
            carregarTab(grupos[indexGrupo]);
        } else {
            carregarTab(grupos[0]);
        }
    }, [isCarregandoGrupo, error, indexGrupo]);

    const selecionarGrupo = (event, grpSelecionado) => {
        const idxGrupo = grupos.findIndex(
            g => g.idGrupoPequeno === grpSelecionado.idGrupoPequeno
        );
        if (idxGrupo !== -1) {
            history.push(`/biblia_on/${idxGrupo}`);
        }
        carregarTab(grpSelecionado);
    };

    const handleSalvarItem = async (
        event,
        idMembro,
        idItem,
        idxMembro,
        idxItem
    ) => {
        const { checked } = event.target;

        try {
            setItens({
                ...itens,
                [MAX_ELEMENTS * idxMembro + idxItem]: checked,
            });
            await salvarDesafio(idItem, idMembro, checked ? 1 : 0);
        } catch (err) {
            setItens({
                ...itens,
                [MAX_ELEMENTS * idxMembro + idxItem]: !checked,
            });
            return false;
        }

        return true;
    };

    return !isCarregandoGrupo && !isCarregandoBibliaOn ? (
        <div className={classes.tab}>
            <AppBar
                position="static"
                style={{ zIndex: 1000, marginBottom: '5px' }}
            >
                <Tabs value={grupoSelecionado} onChange={selecionarGrupo}>
                    {grupos.map((grupo, i) => (
                        <Tab
                            key={grupo.idGrupoPequeno}
                            value={grupo}
                            label={`Grupo ${i + 1}`}
                            {...a11yProps(1)}
                        />
                    ))}
                </Tabs>
            </AppBar>
            <span
                style={{
                    fontWeight: 'bold',
                }}
            >
                {bibliaOn.length > 0 ? `Equipe: ${bibliaOn[0].equipe}` : ''}
            </span>

            <TabPanel value={grupoSelecionado} index={grupoSelecionado}>
                <Grid container spacing={2} className={classes.grid}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            {bibliaOn.map((membro, idxMembro) => (
                                <Grid
                                    key={membro.idMembro}
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                >
                                    <Card>
                                        <CardHeader
                                            avatar={
                                                <Avatar
                                                    className={classes.avatar}
                                                    src={membro.txFotoUrl}
                                                    alt={membro.txMembro}
                                                />
                                            }
                                            title={membro.txMembro}
                                        />
                                        <CardContent
                                            className={classes.cardContent}
                                        >
                                            {membro.itens.map(
                                                (item, idxItem) => (
                                                    <FormControlLabel
                                                        key={
                                                            membro.idMembro +
                                                            item.id
                                                        }
                                                        label={item.nome.toUpperCase()}
                                                        className={classes.item}
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={
                                                                    itens[
                                                                        MAX_ELEMENTS *
                                                                            idxMembro +
                                                                            idxItem
                                                                    ]
                                                                }
                                                                disabled={
                                                                    item.ativo ===
                                                                    '0'
                                                                }
                                                                onChange={event => {
                                                                    handleSalvarItem(
                                                                        event,
                                                                        membro.idMembro,
                                                                        item.id,
                                                                        idxMembro,
                                                                        idxItem
                                                                    );
                                                                }}
                                                            />
                                                        }
                                                    />
                                                )
                                            )}
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </TabPanel>
        </div>
    ) : (
        <div>Carregando...</div>
    );
};

export default Desafio;
